/* * @Author: houxingzhang * @Date: 2019-08-01 09:47:08 * @Last Modified by: qsy.duanrq * @Last Modified time: 2020-04-13 10:26:25 *
方法 loadData // 父级调用组件使用 this.$refs.dataTable.loadData() 进行重载数据 列配置 

/*举例参数格式*/
 <hy-data-table
  v-model="loading"
  height="90%"
  ref="dataTable"
  @find-page="findPage"
  @detail-handle="detailHandle"
  @map-path="mapPath"
  @emit-handle-row-dblclick="emitHandleRowDblclick"
  @all-handle="allHandle"
  is-all-handle
  :data="dataTable.list"
  :columns="dataTable.columns"
  :extend-buttons="dataTable.buttons"
  :show-batch-delete="false"
  :show-operation="true"
  :paging="dataTable.paging"
  size="medium"
  :extend-but-widht="180"
  ></hy-data-table>
 @findPage="findList"  父级查询数据事件,返回dataTable.list，如果配置了api，则不需要配置此项
:data="dataTable.list"  表格需要的数据，如果配置了api，则不需要配置此项
@editHandle="editHandle" 动态按钮事件，与buttons配置的
click:editHandle  一致
@deleteHandle="deleteHandle"  动态按钮事件，与buttons配置的click:deleteHandle一致
@batchDeleteHandel="batchDeleteHandel" 动态按钮事件，与buttons配置的click:batchDeleteHandel一致
@selectionChange="selectionChange"  当前选中的行，多选状态时，选中的回调给父级
:params="params"  查询条件
:api="$api.sys.regionList"  查询的api地址
:columns="dataTable.columns"  显示列表的配置
:extendButtons="dataTable.buttons"  显示操作按钮的配置
:multi-select="true"  是否为多选
:showBatchDelete="{ 
     show:true,  是否可批量删除
     perms:130402, 权限标识
     click: 'batchDeleteHandel' 删除回调
 }"
:deleteParams="{    删除接口配置
key:'regionId',   删除取值字段
keyIsAddS: false, // 接口查询字段是否加后缀s，默认不添加s         
click:'batchDeleteHandel',  删除回调
api: $api.sys.regionDelete,  删除的ＡＰＩ
method:'get' 请求的方法
}"

loading: false, // 是否加载的标识
dataTable:{
    list:{
        "status": "S",
        "msg": "查询成功",
        "count": 765,
        "pageIndex": 1,
        "pageRow": 10,
        "data": [
            {
               "alarmTypeName": "拥堵",
               "alarmTime": "2022-02-23 18:28:36",
               "stationName": "旦架哨隧道南行入口 ( K2082+300 )",
               "statusName": "待确认"
            }
        ]
    },
    columns: [ //跟上面data数组每个  里面的属性一一对应，这是表头label
        { prop: 'alarmTypeName',label: '类型',minWidth: 100,html:dictionary(this.$dictionaryType.REGION_TYPE)},
        { prop: 'alarmTime',label: '时间',minWidth: 100,html:dictionary(this.$dictionaryType.REGION_TYPE)},
        { prop: 'stationName',label: '旦架哨隧道南行入口 ( K2082+300 )',minWidth: 100,html:dictionary(this.$dictionaryType.REGION_TYPE)},
        { prop: 'statusName',label: '状态',minWidth: 100,html:dictionary(this.$dictionaryType.REGION_TYPE)},
    ], 
    buttons: [
        { 
            label: '删除', 
            click: 'deleteHandle', // 按钮回调，返回{index, row} 
            perms: 130404, // 按钮的权限标识
            icon: 'fa fa-trash', // 按钮的图标 
            type: 'danger', // 风格类型 
            insideButton: 'delete' // 是否为内部按钮 ,目前只有 delete(删除)，如果设置delete须配置deletePrams一起使用,未来可扩展modify 
        },
        {
            label: '新增', 
            click: 'addHandle', // 按钮回调，返回{index, row} 
            perms: 130404, // 按钮的权限标识
            type: 'success', // 风格类型 
        } 
    ],
    paging:{
        pageIndex: 1  // 表格分页信息
    }
    }
*/
<template>
  <div class="hy-datatable" style="height: 100%">
    <!--分页栏-->
    <div
      class="toolbar"
      style="padding: 10px; height: 8%"
      v-if="pagingPosition === 'top'"
    >
      <el-button
        style="float: right; margin-left: 20px"
        @click="$emit('allHandle')"
        size="mini"
        type="primary"
        v-if="data.data && data.data.length > 0 && isAllHandle"
        >批量处置</el-button
      >
      <hy-perm-button
        label="批量删除"
        :perms="batchDelete.perms"
        :size="size"
        icon="fa fa-trash"
        type="danger"
        @click="batchDeleteHandel()"
        style="float: left"
        v-if="batchDelete.show"
      ></hy-perm-button>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <el-button
          size="mini"
          circle
          icon="el-icon-menu"
          style="float: right; padding: 6px; margin-left: 10px"
          @click="showColumnsHandel()"
        />
      </el-tooltip>
      <el-pagination
        :layout="
          res.count > 10000
            ? 'prev, pager, next, jumper'
            : 'total, prev, pager, next, jumper'
        "
        @current-change="loadData"
        :current-page="pageRequest.pageIndex"
        :page-size="pageRequest.pageRow"
        :total="res.count > 10000 ? pageMaxsizeTotal : res.count"
        :pageMaxsize="pageMaxsize"
        style="float: right"
        v-if="showPage"
      ></el-pagination>
      <span
        v-if="showPage && res.count > 10000"
        style="
          float: right;
          display: inline-block;
          position: relative;
          top: -3px;
          color: #ccc;
          font-size: 13px;
        "
      >
        共 {{ res.count || res.total }} 条
        <el-tooltip
          class="item"
          effect="dark"
          content="超出10000条记录的无法分页，请重新筛选查询范围，作出更精准的条件查询"
          placement="top-start"
        >
          <el-button class="pageMaxsize_Class" type="text"
            >共 {{ pageMaxsize }}+ 页</el-button
          >
        </el-tooltip>
      </span>
      <span
        style="
          float: right;
          margin-right: 20px;
          padding: 6px;
          display: inline-block;
        "
      >
        <label class="u-color-white">实时刷新</label>
        <el-switch
          :value="isRefreshReportBox"
          active-color="#13ce66"
          @change="changeSwitch"
          inactive-color="#ff4949"
        >
        </el-switch>
      </span>
      <div style="clear: both"></div>
    </div>
    <!--表格栏-->
    <el-table
      :key="elTableKey"
      :data="res.data"
      :highlight-current-row="highlightCurrentRow"
      @selection-change="selectionChange"
      @current-change="handleCurrentChange"
      @row-dblclick="handleRowDblclick"
      v-loading="input"
      element-loading-text="加载中..."
      :border="border"
      :stripe="stripe"
      :row-class-name="tableRowClassName"
      :show-overflow-tooltip="showOverflowTooltip"
      :max-height="maxHeight"
      :height="height"
      :size="size"
      :align="align"
      :closeLoading="input"
      :show-summary="showSummary"
      empty-text="查询结果为空"
      style="width: 100%"
    >
      <el-table-column
        type="selection"
        width="40"
        v-if="batchDelete.show || multiSelect"
      ></el-table-column>
      <el-table-column
        type="index"
        label="序号"
        header-align="center"
        align="center"
        width="50"
        v-if="showIndex"
      ></el-table-column>
      <el-table-column
        type="index"
        label="排名"
        header-align="center"
        align="center"
        width
        :min-width="120"
        v-if="showMyIndex"
        :index="indexMethod"
      ></el-table-column>
      <!-- <el-table-column label="图片" width="100" align="center">
                <template slot-scope="scope">
                    <img @dblclick="$store.commit('set_dbClickImg', scope.row.picPath)" v-if="scope.row.picPath" :src="scope.row.picPath" width="80" height="40" />
                    <div v-if="!scope.row.picPath">暂无图片</div>
                </template>
            </el-table-column> -->
      <template v-for="column in columns">
        <el-table-column
          v-if="column.visible != null ? column.visible : true"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          :min-width="column.minWidth"
          :fixed="column.fixed"
          :key="column.prop"
          :type="column.type"
          :formatter="column.formatter"
          :sortable="column.sortable == null ? false : column.sortable"
        >
          <!-- :sortable="column.sortable==null?true:column.sortable"       取消table排序  后续如果 要排序 再加
        :sortMethod="column.sortMethod"-->
          <template slot-scope="scope">
            <div
              class="overflowTd"
              v-if="column.formatter"
              v-html="
                column.formatter(
                  scope.row,
                  scope.column,
                  scope.row[column.prop],
                  scope.$index
                )
              "
            ></div>
            <div
              class="overflowTd"
              v-else-if="column.html"
              v-html="column.html(scope.row, scope.row[column.prop])"
            ></div>
            <div
              v-else-if="column.normalRateBackgroundColor"
              :style="
                normalRateBackgroundColor(scope.row, scope.row[column.prop])
              "
            >
              {{ scope.row[column.prop] }}
            </div>
            <div class="overflowTd" v-else>{{ scope.row[column.prop]}}</div>
          </template>
        </el-table-column>
      </template>

      <el-table-column
        :label="'操作'"
        :width="btnWidth"
        fixed="right"
        v-if="showOperation"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div class="btn-width">
            <hy-perm-button
              v-for="(btn, key) in extendButtons"
              :key="key"
              :icon="btn.icon"
              :label="
                btn.isEnable
                  ? scope.row[btn.label] == 0
                    ? btn.enableName[0] || '启用'
                    : btn.enableName[1] || '禁用'
                  : btn.label
              "
              :perms="btn.perms"
              :size="btn.size"
              :type="
                btn.isEnable
                  ? scope.row[btn.label] == 0
                    ? btn.typeName[0] || btn.type
                    : btn.typeName[1] || btn.type
                  : btn.type
              "
              @click="extendBtnHandle(btn.click, scope.$index, scope.row, btn)"
              @command="(command)=>{handleCommand(command, scope.row)}"
              :disabled="setButtonDisable(scope.row, scope.$index)"
            ></hy-perm-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div
      v-if="pagingPosition === 'bottom'"
      class="toolbar"
      style="padding: 10px"
    >
      <hy-perm-button
        label="批量删除"
        :perms="batchDelete.perms"
        :size="size"
        type="danger"
        @click="batchDeleteHandel()"
        :disabled="this.selections.length === 0"
        style="float: left"
        v-if="batchDelete.show"
      ></hy-perm-button>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <el-button
          size="mini"
          circle
          icon="el-icon-menu"
          style="float: right; padding: 6px; margin-left: 10px"
          @click="showColumnsHandel()"
        />
      </el-tooltip>
      <el-pagination
        layout="total, prev, pager, next, jumper"
        @current-change="loadData"
        :current-page="pageRequest.pageIndex"
        :page-size="pageRequest.pageRow"
        :total="res.count || res.total"
        :pageMaxsize="pageMaxsize"
        style="float: right"
        v-if="showPage"
      ></el-pagination>

      <div style="clear: both"></div>
    </div>
    <!-- 自定义显示列 -->
    <div>
      <el-dialog
        class="hy-detail"
        title="显示 / 隐藏"
        :visible.sync="dialogVisible"
        width="580px"
        :destroy-on-close="false"
        center
      >
        <div>
          <el-transfer
            v-model="transferValue"
            :data="transferData"
            :titles="['显示', '隐藏']"
            @change="dataChange"
          ></el-transfer>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import HyPermButton from '@/components/HyPermButton.vue';
// import HyPermButton from './HyPermButton';
export default {
  name: 'HyDataTable',
  components: {
    HyPermButton
  },
  props: {
    isAllHandle: {
      type: Boolean,
      default: false
    },
    input: {
      //v-model="xx"
      type: Boolean,
      default: false
    },
    stopLoadData: {
      // 阻止分页
      type: Boolean,
      default: false
    },
    multiSelect: {
      // 是否多选
      type: Boolean,
      default: false
    },
    labelExtend: String,
    labelExtendSecond: String,
    labelCircuit: String,
    columns: Array, // 表格列配置
    data: {
      // 表格分页数据
      type: Object,
      default: () => ({})
    },
    params: Object, // 当数据源为数据库时的请求参数
    api: String, // 查询表的URL接口

    size: {
      // 尺寸样式
      type: String,
      default: 'mini'
    },
    align: {
      // 文本对齐方式
      type: String,
      default: 'left'
    },
    height: [Number, String], // 表格最大高度,
    maxHeight: Number, // 表格最大高度
    showIndex: {
      // 是否显示行号
      type: Boolean,
      default: false
    },
    showMyIndex: {
      // 是否显示自定义行号
      type: Boolean,
      default: false
    },

    border: {
      // 是否显示边框
      type: Boolean,
      default: false
    },
    stripe: {
      // 是否显示斑马线
      type: Boolean,
      default: true
    },
    highlightCurrentRow: {
      // 是否高亮当前行
      type: Boolean,
      default: false
    },
    showOverflowTooltip: {
      // 是否单行显示
      type: Boolean,
      default: true
    },
    showBatchDelete: {
      // 是否显示批量删除组件
      type: [Object, Boolean],
      default: function () {
        return {
          click: null,
          show: false, // 是否显示
          perms: null // 删除权限标识
        };
      }
    },
    deleteParams: {
      // 删除接口的配置参数
      type: Object,
      default: function () {
        return {
          api: null, // 删除接口
          method: 'post', // 请求方法
          key: 'id', // 删除的主键
          keyIsAddS: false, // 接口查询字段是否加后缀s，默认不添加s
          format: 0, // 删除时用于拼接主键的key的值返回格式，０字符串拼接，１数组
          click: null // 点击回调
        };
      }
    },
    showPage: {
      // 是否显示分页
      type: Boolean,
      default: true
    },
    showPageSpan: {
      // 是否显示分页前面的span（总页数）
      type: Boolean,
      default: false
    },

    extendButtons: {
      // 扩展按钮  by hxz 2019-4-17
      type: Array, // [{icon="fa fa-gavel" label="扩展按钮" perms="perms" size="size" type="success"}]
      default: () => []
    },
    extendButWidht: {
      type: Number, // 扩展操作栏按钮的宽 ,如果没有这个值则自动计算
      default: 240
    },
    rowDisabled: Function, // 行禁用 function (row, index) 必须要 return boolean
    rowDisabledBtn: Function, // 按钮是否置灰 function (row, index) 必须要return boolean
    paging: {
      // 分页信息
      type: Object,
      default: function () {
        return {
          pageIndex: 1,
          pageRow: 10,
          total: 0
        };
      }
    },
    pageMaxsize: {
      type: Number,
      default: 300
    },
    pageMaxsizeTotal: {
      type: Number,
      default: 300
    },
    showSummary: {
      // 是否显示表尾合计行
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // isRefresh:false,
      elTableKey: 'k1',
      pagingPosition: 'bottom',
      btnWidth: 0, // 扩展按钮的宽度
      res: {},
      computedBtnWidth: 0, // 计算按钮宽度
      selections: [], // 列表选中列
      dialogVisible: false,
      transferData: [],
      transferValue: []
    };
  },
  computed: {
    ...mapState({
      isRefreshReportBox: (state) => state.isRefreshReportBox
    }),
    showOperation() {
      return this.extendButtons && this.extendButtons.length > 0;
    },
    batchDelete() {
      const newObj = this.showBatchDelete;
      const obj = {
        click: null,
        show: false, // 是否显示
        perms: null // 删除权限标识
      };
      return { ...obj, ...newObj };
    },
    deleteConfig() {
      const newObj = this.deleteParams;
      const obj = {
        api: null, // 删除接口
        method: 'post', // 请求方法
        key: 'id', // 删除的主键
        keyIsAddS: false, // 接口查询字段是否加后缀s，默认不添加s
        format: 0, // 删除时用于拼接主键的key的值返回格式，０字符串拼接，１数组
        click: null // 点击回调
      };
      return { ...obj, ...newObj };
    },

    // 分页信息
    pageRequest() {
      const obj = this.paging;
      if (!obj.pageRow) obj.pageRow = 10;
      obj.currentPage = this.paging.pageIndex; // 兼容旧代码的 currentPage
      obj.pageSize = this.paging.pageRow; // 兼容旧代码的 pageSize
      return obj;
    }
  },
  watch: {
    // by hxz 2019-5-6
    data: {
      handler: function (nval, oval) {
        this.res = nval;
        setTimeout(() => {
          this.setBtnWidht(nval, oval);
        }, 50);
      },
      deep: true
    }
  },
  methods: {
    changeSwitch(val) {
      console.log(val);
      this.$store.commit('set_alarmConfigRefresh', { isRefreshReportBox: val });
    },
    tableRowClassName({ row, rowIndex }) {
      return (
        typeof this.rowDisabled === 'function' &&
        this.rowDisabled(row, rowIndex) &&
        'disabled-row'
      ); // 根据条件设置禁用样式   // by hxz 2019-6-22
    },
    setButtonDisable(row, rowIndex) {
      return (
        typeof this.rowDisabledBtn === 'function' &&
        this.rowDisabledBtn(row, rowIndex)
      ); // 根据条件设置按钮禁用状态   // by hxz 2019-6-22
    },
    setBtnWidht(nval, oval) {
      let w = 20; // 两边的padding值总合  by 2019-5-6
      const btnBox = document.querySelector('.btn-width');
      if (btnBox) {
        const btnlist = btnBox.querySelectorAll('button');
        if (!btnlist || btnlist.length === 0) return;
        for (let i = 0; i < btnlist.length; i++) {
          const item = btnlist[i];
          if (item.offsetWidth === 0) {
            const btnwidth = 32; // 当前的按钮的 padding值
            const txtWidht = item.innerText.trim().length * 13.5; // 字数的宽度
            if (item.querySelector('i')) {
              w += btnwidth + txtWidht + 12 + 10; // 12 为当前iconfont 的宽
            } else {
              w += btnwidth + txtWidht + 10;
            }
          } else {
            w += item.offsetWidth + 10; // 10为按钮的margin值
          }
          // console.log(item.offsetWidth)
        }
      }
      if (this.extendButWidht && this.extendButWidht > w) {
        this.btnWidth = this.extendButWidht;
      } else {
        this.btnWidth = w;
      }
    },
    // by hxz 2019-4-17
    extendBtnHandle: function (btnEvent, index, row, btn) {
      if (btn.insideButton && btn.insideButton === 'delete') {
        // 类型为内置删除按钮
        this.deleteEvent(row[this.deleteConfig.key], btnEvent);
      } else {
        const obj = JSON.parse(JSON.stringify(row));
        this.$emit(btnEvent, { index: index, row: obj});
      }
    },
    handleCommand: function (command,row) {
        const obj = JSON.parse(JSON.stringify(row));
        this.$emit('qrcode-handle', { row: obj,command:command});
    },
    indexMethod(index) {
      // this.$emit('indexMethod', {index:index})
      return (
        index + (this.pageRequest.pageIndex - 1) * this.pageRequest.pageRow + 1
      );
    },
    // 分页查询
    findPage: function () {
      if (this.api) {
        this.input = true;
        const data = {
          pageIndex: this.pageRequest.pageIndex,
          pageRow: this.pageRequest.pageRow,
          ...this.params
          // params: JSON.stringify(p)
        };
        this.$axios({
          url: this.api,
          method: 'post',
          data
        })
          .then((res) => {
            this.res = res;
            this.input = false;
            setTimeout(() => {
              this.setBtnWidht();
            }, 50);
          })
          .catch((error) => {
            this.input = false;
            // this.$message({
            //   showClose: true,
            //   message: error,
            //   type: 'error'
            // })
          });
        return;
      }
      const callback = (res) => {
        this.input = false;
      };
      this.$emit('find-page', {
        pageRequest: this.pageRequest,
        paging: this.pageRequest,
        callback: callback
      });
    },
    // 选择切换
    selectionChange: function (selections) {
      this.selections = selections;
      this.$emit('selectionChange', { selections: selections });
    },
    // 选择切换
    handleCurrentChange: function (val) {
      this.$emit('handleCurrentChange', { val: val });
    },
    // 换页刷新  调用组件的页面可以使用 this.$refs.hyDataTable.loadData() 进行重载数据
    loadData: function (pageNum) {
      // let pageMax =  300
      // let nowPage = pageNum < 0 ? this.pageRequest.pageIndex : pageNum || 1
      // if (nowPage > pageMax) {
      //   this.$message({
      //     showClose: true,
      //     message: '超出10000条记录的无法分页，请重新筛选查询范围，作出更精准的条件查询',
      //     type: 'warning'
      //   })
      //   return null
      // } else {
      //   this.pageRequest.pageIndex = pageNum < 0 ? this.pageRequest.pageIndex : pageNum || 1
      //   this.findPage()
      // }
      this.pageRequest.pageIndex =
        pageNum < 0 ? this.pageRequest.pageIndex : pageNum || 1;
      this.findPage();
    },
    // 单行删除
    deleteHandel: function (index, row, callbackEvent) {
      // this.deleteEvent(row[this.deleteConfig.key], callbackEvent)
    },
    // 批量删除
    batchDeleteHandel: function () {
      if (this.selections.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择需要删除的数据！',
          type: 'warning'
        });
        return null;
      }
      let ids = this.selections.map((item) => item[this.deleteConfig.key]);
      ids = this.deleteConfig.format === 0 ? ids.toString() : ids; // 根据格式化类型转化字符串或数组
      this.deleteEvent(ids, this.batchDelete.click);
    },

    // 删除操作
    deleteEvent: function (ids, callbackEvent) {
      this.$confirm('确认删除选中记录吗？', '提示', {
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '删除中...';
            const callback = (res) => {
              if (res.status === 'S') {
                this.$message({ message: '删除成功', type: 'success' });
              } else {
                this.$message({
                  message: '操作失败, ' + res.msg,
                  type: 'error'
                });
              }
              instance.confirmButtonLoading = false;
              done();
              this.loadData(-1);
            };

            // 有删除api直接在内部删除
            if (this.deleteConfig.api) {
              let keys = null;
              if (this.deleteConfig.keyIsAddS) {
                keys = this.deleteConfig.key + 's';
              } else {
                keys = this.deleteConfig.key;
              }
              const data = {
                [keys]: ids
              };
              const params =
                this.deleteConfig.method === 'post' ? 'data' : 'params';
              this.$axios({
                url: this.deleteConfig.api,
                method: this.deleteConfig.method,
                [params]: data
              }).then((res) => {
                callback(res);
                if (callbackEvent) this.$emit(callbackEvent, { ids, res });
              });
            } else {
              if (callbackEvent) {
                this.$emit(callbackEvent, { ids, callback });
              } else {
                this.$message({
                  message: '无法删除，必须设置删除回调或配置删除接口api参数',
                  type: 'error'
                });
                instance.confirmButtonLoading = false;
                done();
              }
            }
          } else {
            instance.confirmButtonLoading = false;
            done();
          }
        }
      });
    },
    /** 对正常流水率添加背景色
     *  大于等于90%标绿色，大于等于85%小于90%标黄色，小于85%标红色
     */
    normalRateBackgroundColor(row, prop) {
      // debugger
      let normalRate = prop ? parseFloat(prop) : null;
      if (normalRate == null) {
        return prop;
      } else if (normalRate >= 90) {
        return 'border: 1px solid #67c23a;background-color: #67c23a;color: #fff;padding: 0 10px;border-radius: 4px;width:60px;box-sizing: border-box;margin: 0 auto;';
      } else if (normalRate >= 85 && normalRate < 90) {
        return 'border: 1px solid #FF8000;background-color: #FF8000;color: #fff;padding: 0 10px;border-radius: 4px;width:60px;box-sizing: border-box;margin: 0 auto;';
      } else if (normalRate < 85) {
        return 'border: 1px solid #FF4A4A;background-color: #FF4A4A;color: #fff;padding: 0 10px;border-radius: 4px;width:60px;box-sizing: border-box;margin: 0 auto;';
      }
      return prop;
    },
    // 当某一行被双击时会触发该事件
    handleRowDblclick(row, column, event) {
      let data = {
        row: row,
        column: column,
        event: event
      };
      this.$emit('emitHandleRowDblclick', data);
    },
    // 自定义显示列
    showColumnsHandel() {
      this.dialogVisible = true;
    },
    // 右侧列表元素变化
    dataChange(data) {
      for (var item in this.transferData) {
        debugger;
        const key = this.transferData[item].key;
        this.transferData[item].visible = !data.includes(key);
        this.columns[key].visible = !data.includes(key);
      }
      this.elTableKey += 1;
    }
  },
  mounted() {
    let showColumnsArr = [];
    for (let i = 0; i < this.columns.length; i++) {
      const element = this.columns[i];
      showColumnsArr.push({ key: i, label: element.label, visible: true });
    }
    this.transferData = showColumnsArr;
    this.loadData(1);
    if (this.data) this.res = this.data;
    this.setBtnWidht();
  }
};
</script>
<style lang="scss">
.overflowTd {
  width: 100%;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容*/
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用*/
}
.hy-datatable {
  .el-table .cell {
    overflow: inherit;
  }
  .el-table .warning-row {
    background: oldlace;
  }
  .el-pagination__jump {
    color: #ccc !important;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table .disabled-row td {
    cursor: no-drop;
    background: #f8f8f8 !important;
    color: #ccc !important;
  }
  .hy-form .el-input {
    width: 190px;
  }

  .hy-form .inputPlatePrefix .el-input {
    width: 60px;
  }

  .hy-form .inputCarnumber .el-input {
    width: 116px;
  }

  .hy-form .inputDateTime .el-input {
    width: 190px;
  }
  .pageMaxsize_Class {
    color: #ccc;
    margin-left: 10px;
    font-size: 13px;
    position: inherit;
    /* top: -1px; */
  }
  .pageMaxsize_Class span {
    font-size: 13px;
  }
  .three-phase-top {
    border-bottom: 1px dashed rgb(235, 238, 245);
  }
  /* edit by hxz 2019-4-28 */
  .btn-width {
    white-space: nowrap;
  }
  .hy-datatable,
  .toolbar {
    &::before,
    &::after {
      display: table;
      content: '';
    }
  }
  ::v-deep .el-dialog {
    background-color: #0c447c !important;
    .el-dialog__body {
      padding: 20px 40px;
    }
  }
  ::v-deep .el-transfer__button {
    border-radius: 50%;
    padding: 12px;
    display: block;
    margin-left: 0px;
  }
  ::v-deep .el-transfer__button:first-child {
    margin-bottom: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/HyDataTable.vue